// extracted by mini-css-extract-plugin
module.exports = {"root":"IngridTracking_root__Cmjlo","container":"IngridTracking_container__Jd6KX","title":"IngridTracking_title__Ps909"};